import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  FormInputSelectComponent,
  IObjectOption,
  SelectOption,
} from '../form-input-select.component';
import { ToSelectOptionAttributePipe } from '../../../../pipes/to-select-option-attribute/to-select-option-attribute.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'aw-multi-select',
  imports: [
    CommonModule,
    ErrorMessageComponent,
    ReactiveFormsModule,
    ToSelectOptionAttributePipe,
    AppendTestIdPipe,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './multi-select.component.html',
})
export class MultiSelectComponent
  extends FormInputSelectComponent
  implements OnDestroy
{
  private readonly attributePipe: ToSelectOptionAttributePipe =
    new ToSelectOptionAttributePipe();

  constructor(public override ngControl: NgControl) {
    super(ngControl);
    this.subscription.add(
      fromEvent<
        KeyboardEvent & { target?: { id: string; value: SelectOption } }
      >(document, 'keyup').subscribe(event => {
        const index: number = +event.target?.id?.split('-')[2];
        const isCorrectTarget = event.target?.id === this.id() + '-' + index;
        if (event.key === 'Enter' && isCorrectTarget) {
          event.preventDefault();
          this.selectOption(this.options()[index]);
        }
      })
    );
  }

  protected pickAttributeFromChosenOptions(): any[] {
    return (
      this.ngControl.control!.value?.map((value: any) =>
        this.attributePipe.transform(value, this.valueAttribute())
      ) ?? []
    );
  }

  public override selectOption(option: SelectOption): void {
    if (!this.ngControl.control!.disabled) {
      const chosenOption = this.attributePipe.transform(
        option,
        this.valueAttribute()
      );
      const presentOptions = this.pickAttributeFromChosenOptions() ?? [];
      const isValuePresent: boolean = presentOptions.includes(chosenOption);

      const newValue = isValuePresent
        ? presentOptions.filter(value => value !== chosenOption)
        : presentOptions.concat([chosenOption]);

      if (this.ngControl.control) {
        this.ngControl.control!.setValue(newValue);
        this.ngControl.control!.markAsTouched();
      }
    }
  }
}
